import React, { MouseEvent } from "react"

import { Player } from "live/modules"
import { VodPlayer } from "vod/contexts"

interface Props {
  player?: Player | VodPlayer | null
}

export default function FullMode({ player }: Props) {
  if (!player) {
    return null
  }

  return (
    <li className="ty03">
      <a
        href="#!"
        title="전체창"
        onClick={(e: MouseEvent) => {
          e.preventDefault()
          player.requestFullscreen()
        }}
      >
        <i>-</i>전체창
      </a>
    </li>
  )
}
